import { render, staticRenderFns } from "./fragment-gfx3d-form.vue?vue&type=template&id=2dbcac7a&scoped=true&"
import script from "./fragment-gfx3d-form.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx3d-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbcac7a",
  null
  
)

export default component.exports